import {type FC, useEffect, useState} from "react";

type Props = {
    value: string;
    label?: string;
};

/** Clipboard API needs a secure context; the cabinet is served over https. */
export const CopyButton: FC<Props> = (props) => {
    const {value, label = "Копировать"} = props;
    const [copied, setCopied] = useState(false);

    useEffect(() => {
        if (!copied) {
            return;
        }

        const timer = setTimeout(() => setCopied(false), 2000);

        return () => clearTimeout(timer);
    }, [copied]);

    const copy = async () => {
        await navigator.clipboard.writeText(value);
        setCopied(true);
    };

    return (
        <button type="button" className="outline copy" onClick={copy}>
            {copied ? "Скопировано" : label}
        </button>
    );
};
